import { message } from 'antd';
import { makeAutoObservable, runInAction } from 'mobx';
import ITask from '../../models/task';
import ITaskCriteria from '../../models/task-criteria';
import { TaskService } from '../../services/task-service';
import TaskItemStore from './task-item';
import Subjects from '../../models/subjects';
import Pagination from '../../models/pagination';

export default class TaskListStore {

    data: TaskItemStore[];
    page: number;
    pageSize: number;
    totalCount: number;
    criteria: ITaskCriteria;
    subject: Subjects;
    taskService: TaskService;
    loading: boolean;

    constructor(subject: Subjects) {
        this.data = [];
        this.page = 1;
        this.pageSize = Pagination.PAGE_SIZE;
        this.totalCount = 0;
        this.criteria = {} as ITaskCriteria;
        this.taskService = new TaskService();
        this.subject = subject;
        this.loading = false;

        makeAutoObservable(this);
    }

    initTask(): void {
        this.filterTask(this.criteria);
    }

    filterTask(criteria: ITaskCriteria, page?: number, pageSize?: number): void {

        try {

            this.loading = true;
            this.page = page || 1;
            this.pageSize = pageSize || Pagination.PAGE_SIZE

            var params = {
                ...criteria,
                page: this.page - 1,//antd starts pagination from 1, Spring from 0
                size: this.pageSize
            };
            const urlParams = new URLSearchParams(JSON.parse(JSON.stringify(params)));
console.log(this.page + ' ||| ' + this.pageSize);
            this.taskService.search(this.subject, urlParams).then(
                data => {
                    const tasks = data['content'] as ITask[];
                    this.data = tasks.map(t => new TaskItemStore(t, this.subject, this.taskService));
                    this.totalCount = data['totalElements'];
                    this.loading = false;
                },
                error => {
                    message.error(error);
                    this.loading = false;
                }
            );

        } catch (error) {
            runInAction(() => { message.error(error) });
        }
    }

    deleteTask(taskId: number) {
        try {
            this.taskService.delete(taskId).then(
                (response) => {

                    if (response.ok) {
                        this.filterTask(this.criteria);
                    } else {
                        response.json().then(error => message.error(error['detail']));
                    }
                }
            );
        } catch (error) {
            runInAction(() => {
                message.error(`Ошибка при удалении задачи: ${error}`);
            });
        }
    }
}